import * as db from './db.js' //引入common
import store from './../store'
import cookie from '../utils/store/cookie'
import {
	VUE_APP_RESOURCES_URL as imgUrl,
	VUE_APP_API_URL
} from '@/config/index.js'
// 上传图片
export const uploadImage = (num = 1, callback) => {
	uni.chooseImage({
		count: num,
		success: (res) => {
			uni.showLoading({
				title: '上传中...'
			});
			let tempFilePaths = res.tempFilePaths
			for (var i = 0; i < tempFilePaths.length; i++) {
				uni.uploadFile({
					url: VUE_APP_API_URL + '/api/upload',
					file: tempFilePaths,
					name: 'file',
					filePath: tempFilePaths[i],
					header: {
						'appid': 'wx463e6770fd76ccdb',
						'Authorization': 'Bearer ' + cookie.get('login_status'),
					},
					success: (uploadFileRes) => {
						callback(JSON.parse(uploadFileRes.data));
					},
					fail: (error) => {
						error && error.response && showError(error.response)
					},
					complete: () => {
						setTimeout(function () {
							uni.hideLoading();
						}, 250);
					}
				});
			}
		}
	})
}
//把obj对象里的值覆盖到newobj里面
function deepCopy(newobj, obj) {
	if (typeof obj != 'object') {
		return obj
	}
	for (var attr in obj) {
		var a = {}
		if (newobj[attr]) {
			a = newobj[attr]
		}
		newobj[attr] = deepCopy(a, obj[attr])
	}
	return newobj
}

//跳转到登陆页面
function jumpToLogin() {
	uni.showToast({
		title: '请先登录',
		icon: 'none',
		duration: 1000,
		success: function (res) {
			setTimeout(() => {
				uni.hideToast();
				let pages = getCurrentPages();
				let currentPages = pages[pages.length - 1];
				let redirectUrl = currentPages.$page.fullPath;
				db.set('redirectUrl', redirectUrl);
				uni.navigateTo({
					url: `/pages/login/login`,
					animationType: 'pop-in',
					animationDuration: 200
				})
			}, 666)
		}
	})
}

//当出错的时候，显示错误信息，并且跳转 弃用
function errorToBack(msg = '出错了，请重试', delta = 1) {
	uni.showToast({
		title: msg,
		icon: 'none',
		duration: 2000,
	});
	if (delta > 0) {
		setTimeout(function () {
			uni.navigateBack({
				delta: delta
			})
		}, 1000);
	}
}
//操作成功后，的提示信息
function successToShow(msg = '保存成功', callback = function () { }) {
	setTimeout(function () {
		uni.showToast({
			title: msg,
			icon: 'none',
			duration: 2000,
			success() {
				setTimeout(function () {
					callback()
				}, 2000)
			}
		})
	}, 100)
}

//操作失败的提示信息
function errorToShow(msg = '操作失败', callback = function () { }) {
	setTimeout(function () {
		uni.showToast({
			title: msg,
			icon: 'none',
			duration: 2000,
			success() {
				setTimeout(function () {
					callback()
				}, 2000)
			}
		})
	}, 100)
}

//加载显示
function loadToShow(msg = '加载中') {
	uni.showToast({
		title: msg,
		icon: 'loading'
	})
}

//加载隐藏
function loadToHide() {
	uni.hideToast()
}


//不足位数前面补0
function showNum(num, length) {
	return (Array(length).join('0') + num).slice(-length)
}


/**
 * 保留当前页，跳转到某页
 */
function navigateTo(url) {
	uni.navigateTo({
		url: url,
		animationType: 'pop-in',
		animationDuration: 300
	})
}
/**
 *  关闭其它页面，跳转到tab页面
 */
function switchTab(url) {
	uni.switchTab({
		url: url,
		animationType: 'pop-in',
		animationDuration: 300
	})
}

/**
 *  关闭当前页面并跳转
 */
function redirectTo(url) {
	uni.redirectTo({
		url: url,
		animationType: 'pop-in',
		animationDuration: 300
	})
}

/**
 *  返回上一个页面
 */
function back() {
	uni.navigateBack();
}

/**
 * 获取url参数
 *
 * @param {*} name
 * @param {*} [url=window.location.serach]
 * @returns
 */
function getQueryString(name, url) {
	var url = url || window.location.href
	var reg = new RegExp('(^|&|/?)' + name + '=([^&|/?]*)(&|/?|$)', 'i')
	var r = url.substr(1).match(reg)
	if (r != null) {
		return r[2]
	}
	return null
}

/**
 * 线上图片路径
 */
function serviceImg(url) { //imgUrl + url
	return `${imgUrl}${url}`
}


/**
 * 查看地图查看位置
 * @param latitude 经度
 * @param longitude 纬度
 */
function lookSite(latitude, longitude, address) {
	uni.openLocation({
		latitude: Number(latitude),
		longitude: Number(longitude),
		name: address,
		fail: error => {
			errorToShow(error.errMsg);
		}
	});
}

/**
 * 拨打电话
 * @param phone 手机号
 */
function dialPhone(phoneNumber) {
	uni.makePhoneCall({
		phoneNumber: String(phoneNumber)
	});
}


function proview(url) {
	if (url) {
		uni.previewImage({
			urls: [url],
			current: 0
		})
	}
}

function proviewArr(arr, i) {
	if (arr && arr.length > 0) {
		uni.previewImage({
			urls: arr,
			current: i
		})
	}
}

function checkObject(obj, check) { //检测对象非空
	let flag = true
	for (let key in obj) {
		if (!obj[key] || obj[key].length == 0) {
			errorToShow(check[key]);
			flag = false
		}
	}
	return flag
}



// 非正常 地址栏的参数
function handleQrCode() {
	var urlSpread = parseQuery()['q']; // 自己登录和扫码都为空

	if (urlSpread) {
		if (urlSpread.indexOf('%3F') != -1) {
			// 通过海报二维码进来   http://kjjsc.askjhb.com/pages/home/index?spread=3612
			urlSpread = urlSpread
				.split("%3F")[1] // %3F  ? 'spread=3612&code=12345645&logintype=wechat'
				.replace(/%3D/g, ":") // %3D   = 		'spread:3612,code:12345645,logintype:wechat'
				.replace(/%26/g, ",") //  %26   &		'spread:3612,code:12345645,logintype:wechat'
				.split(",") // ['spread:3612' ,'code:12345645','logintype:wechat'] 
				.map((item, index) => {
					item = item.split(
						":"
					); //  ['spread'] ['3612']     ['code'] ['12345645']   ['logintype'] ['wechat'] 
					return `"${item[0]}":"${item[1]}"`; // {spread: '3612'}  {code: '123465'}   {logintype: wechat}
				})
				.join(",");
			urlSpread = JSON.parse("{" + urlSpread + "}");
			return urlSpread //  {spread: 34615}
		} else {
			// 返回正常地址栏的参数
			return handleUrlParam(urlSpread)
		}
	}
	return null
}
// 返回正常地址栏的参数
function handleUrlParam(path) {
	var url = path.split("?")[1]; //获取url中"?"符后的字串
	var theRequest = new Object();
	if (path.includes("?")) {
		var url = path.split("?")[1]; //获取url中"?"符后的字串
		let strs = url.split("&");
		for (var i = 0; i < strs.length; i++) {
			theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
		}
	}
	return theRequest; //  {spread: 131}
}
// 截取当前地址栏中的参数 判断是从哪个页面中来的 返回值就是一个当前传递的参数的对象的集合
export function parseQuery() {
	let res = {};


	// 截取当前url 后面参数的值  将？
	const query = (location.href.split("?")[1] || "") // 'spread=123&code=456789' 字符串
		.trim()
		.replace(/^(\?|#|&)/, ""); // 将元素中含有 ? #  & 都替换为

	if (!query) {
		return res;
	}
	// 将每个参数分割成一个数组  ['spread=3216', 'code=324564', 'logintype=14561']
	query.split("&").forEach(param => {
		const parts = param.replace(/\+/g, " ").split("="); // ['spread', '3216']
		// decodeURIComponent 解码
		const key = decodeURIComponent(parts
			.shift()); // ['spread', '3216']  删除从第一个元素的  并返回这个元素  这个时候parts 为 ['3216'] 这个属性值了
		const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

		if (res[key] === undefined) {
			res[key] = val;
		} else if (Array.isArray(res[key])) {
			res[key].push(val);
		} else {
			res[key] = [res[key], val];
		}
	});







	let str = JSON.stringify(res)
	return res
}

/*获取当前页url*/
export function getCurrentPageUrl() {
	var pages = getCurrentPages(); //获取当前页面栈的实例，以数组形式按栈的顺序给出，第一个元素为首页，最后一个元素为当前页面
	var currentPage = pages[pages.length - 1]; //获取当前页面
	var url = currentPage.route; //当前页面url  页面地址
	return url;
}

// 获取 一个带有参数的地址的url
export function getCurrentPageUrlWithArgs() {
	var pages = getCurrentPages(); // 获取当前页面栈的实例。是一个数组 第一个元素为首页 ，最后一个元素为当前页面
	var currentPage = pages[pages.length - 1] //获取当前页面
	var url = currentPage.route; //当前页面url
	var options = currentPage.options //如果要获取url中所带的参数可以查看options
	//拼接url的参数
	var urlWithArgs = url + '?'
	for (var key in options) {
		var value = options[key]
		urlWithArgs += key + '=' + value + '&'
	}
	// 到这里已经是一个字符串  然后截取字符串  获得
	urlWithArgs = urlWithArgs.substring(0, urlWithArgs.length - 1)
	// 最后这里返回的就是一个地址 加上含有参数的 地址  "http://angsheng.com?id=1&name=chentao"
	return urlWithArgs
}




export {
	back,
	lookSite,
	serviceImg,
	deepCopy,
	jumpToLogin,
	errorToBack,
	successToShow,
	errorToShow,
	loadToShow,
	loadToHide,
	navigateTo,
	redirectTo,
	getQueryString,
	dialPhone,
	switchTab,
	proview,
	proviewArr,
	checkObject,
	showNum,
	handleQrCode,
	handleUrlParam,
}